import { handleValidationChange } from '../CommonValidation';

export const validateCreditCards = (data, setIsError) => {
    //Required
    // name, card_name, card_no, issuing_bank, credit_limit, statement_date, due_date

    var isValid = true;

    if (!data.name || data.name.trim() === "") {
        handleValidationChange("name", "Card display name is required", setIsError);
        isValid = false;
    } else {
        handleValidationChange("name", "", setIsError);
    }

    if (!data.card_name || data.card_name.trim() === "") {
        handleValidationChange("card_name", "Name on card is required", setIsError);
        isValid = false;
    } else {
        handleValidationChange("card_name", "", setIsError);
    }

    if (!data.card_no || data.card_no.toString().trim() === "") {
        handleValidationChange("card_no", "Card number is required", setIsError);
        isValid = false;
    } else {
        handleValidationChange("card_no", "", setIsError);
    }

    if (!data.issuing_bank || data.issuing_bank.trim() === "") {
        handleValidationChange("issuing_bank", "Issuing bank is required", setIsError);
        isValid = false;
    } else {
        handleValidationChange("issuing_bank", "", setIsError);
    }

    if (!data.credit_limit || data.credit_limit.toString().trim() === "") {
        handleValidationChange("credit_limit", "Credit limit is required", setIsError);
        isValid = false;
    } else if (!/^\d+(\.\d{1,2})?$/.test(data.credit_limit)) {
        handleValidationChange("credit_limit", "Credit limit must be a valid number (up to 2 decimal places)", setIsError);
        isValid = false;
    } else {
        handleValidationChange("credit_limit", "", setIsError);
    }

    if (!data.statement_date || data.statement_date.toString().trim() === "") {
        handleValidationChange("statement_date", "Statement day is required", setIsError);
        isValid = false;
    } else if (!/^\d+$/.test(data.statement_date) || Number(data.statement_date) < 1 || Number(data.statement_date) > 31) {
        handleValidationChange("statement_date", "Statement day must be a whole number from 1 to 31", setIsError);
        isValid = false;
    } else {
        handleValidationChange("statement_date", "", setIsError);
    }

    if (!data.due_date || data.due_date.toString().trim() === "") {
        handleValidationChange("due_date", "Due day is required", setIsError);
        isValid = false;
    } else if (!/^\d+$/.test(data.due_date) || Number(data.due_date) < 1 || Number(data.due_date) > 31) {
        handleValidationChange("due_date", "Due day must be a whole number from 1 to 31", setIsError);
        isValid = false;
    } else {
        handleValidationChange("due_date", "", setIsError);
    }

    return isValid

}